import React, { useState, useEffect } from 'react';
import Styles from '../components/Depoimentos.module.css';
import d1 from '../img/d1.jpg';
import d2 from '../img/D2.jpg';
import d3 from '../img/D3.JPG'
import d4 from '../img/D4.jpeg';
import d5 from '../img/D5.jpeg';
import d6 from '../img/D6.png';
import d7 from '../img/D7.jpeg';

const depoimentos = [
  { id: 1, foto: d1 },
  { id: 2, foto: d2 },
  { id: 3, foto: d3 },
  { id: 4, foto: d4 },
  { id: 5, foto: d5 },
  { id: 6, foto: d6 },
  { id: 7, foto: d7 },
];

const Depoimentos = () => {
  const [indiceAtual, setIndiceAtual] = useState(0);
  const [animar, setAnimar] = useState(false);

  const mudarSlide = (proximo) => {
    setAnimar(false);
    setTimeout(() => {
      setIndiceAtual((prevIndice) =>
        proximo 
          ? (prevIndice + 2) % depoimentos.length 
          : prevIndice === 0 
            ? depoimentos.length - 2 
            : prevIndice - 2
      );
      setAnimar(true); // Ativa a animação para o novo slide
    }, 500);
  };

  // Auto slide a cada 3 segundos
  useEffect(() => {
    const intervalo = setInterval(() => {
      mudarSlide(true);
    }, 3000);

    return () => clearInterval(intervalo);
  }, []);

  return (
    <div>
      <div className={Styles.areaDepoimentos}>
        <blockquote>
          Muitos começam fortes e desanimam no caminho. O importante não é como você começa, mas como você termina e
          eu tenho certeza de que você terminará mais forte do que começou.
        </blockquote>
      </div>
      <div className={Styles.carrosselWrapper}>
        <div className={Styles.carrosselContainer}>
          <button className={Styles.btnAnterior} onClick={() => mudarSlide(false)}>
            &#10094;
          </button>
          <div className={Styles.slideContainer}>
            <div className={`${Styles.slide} ${animar ? Styles.fatherEffect : ''}`}>
              <div className={Styles.imagemContainer} style={{ display: 'flex', gap: '10px' }}>
                <img className={Styles.foto} src={depoimentos[indiceAtual].foto} alt='Depoimento' />
                <img
                  className={Styles.foto}
                  src={depoimentos[(indiceAtual + 1) % depoimentos.length].foto}
                  alt='Depoimento'
                />
              </div>
            </div>
          </div>
          <button className={Styles.btnProximo} onClick={() => mudarSlide(true)}>
            &#10095;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Depoimentos;
